module.exports = __webpack_public_path__ + "img/salt_1.1493d07d.png";